import React from 'react';
import styled from 'styled-components';
import { IntegrationProvider } from 'api/integrations';
import { ReactComponent as HubspotLogo } from 'assets/svgs/hubspot-logo.svg';
import { ReactComponent as JiraIcon } from 'assets/svgs/jira-logo.svg';
import { ReactComponent as SalesforceLogo } from 'assets/svgs/salesforce-logo.svg';
import { ReactComponent as SlackLogo } from 'assets/svgs/slack-logo.svg';
import { ReactComponent as WorkatoLogo } from 'assets/svgs/workato-logo.svg';
import { ReactComponent as ZapierLogo } from 'assets/svgs/zapier-logo.svg';
import { CardLinkProps } from 'components/molecules/card-link';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';

const JiraLogo = styled(JiraIcon)`
  width: 32px;
  height: 32px;
`;

interface IntegrationDetails extends CardLinkProps {
  key: string;
  icon: JSX.Element;
  enabled: boolean;
}

export const IntegrationCardDetails = (): IntegrationDetails[] => {
  const integrationlist = [
    {
      key: IntegrationProvider.Zapier,
      title: useTranslation('settings.integrations.zapier.title'),
      description: useTranslation('settings.integrations.zapier.description'),
      icon: <ZapierLogo />,
      link: { to: RoutePaths.zapierIntegration },
      enabled: true,
    },
    {
      key: IntegrationProvider.Jira,
      title: useTranslation('settings.integrations.jira.title'),
      description: useTranslation('settings.integrations.jira.description'),
      icon: <JiraLogo />,
      link: { to: RoutePaths.jiraIntegration },
      enabled: true,
    },
    {
      key: IntegrationProvider.SalesForce,
      title: useTranslation('settings.integrations.sf.title'),
      description: useTranslation('settings.integrations.sf.description'),
      icon: <SalesforceLogo />,
      link: { to: RoutePaths.salesforceIntegrations },
      enabled: true,
    },
    {
      key: IntegrationProvider.Slack,
      title: useTranslation('settings.integrations.slack.title'),
      description: useTranslation('settings.integrations.slack.description'),
      icon: <SlackLogo />,
      link: { to: RoutePaths.slackIntegration },
      enabled: true,
    },
    {
      key: IntegrationProvider.Workato,
      title: useTranslation('settings.integrations.workato.title'),
      description: useTranslation('settings.integrations.workato.description'),
      icon: <WorkatoLogo />,
      link: { to: RoutePaths.workatoIntegration },
      enabled: true,
    },
    {
      key: IntegrationProvider.Hubspot,
      title: useTranslation('settings.integrations.hubspot.title'),
      description: useTranslation('settings.integrations.hubspot.description'),
      icon: <HubspotLogo />,
      link: { to: RoutePaths.hubspotIntegration },
      enabled: true,
    },
  ];

  return integrationlist;
};
